/* ============================================================
   Monmouth Cards — Cart JS
   assets/monmouth-cart.js
   ============================================================
   Handles: cart drawer open/close, AJAX qty updates,
   remove items, discount code, upsell add-to-cart,
   free shipping bar, cart count badge.
   ============================================================ */
(function () {
  'use strict';

  /* Real fix (cart-js-double-inclusion-prompt.md) — this file was
     confirmed loading twice on the real cart page (once sitewide via
     theme.liquid, once redundantly via sections/monmouth-cart.liquid),
     and the two copies didn't even execute back-to-back since one was
     deferred and one wasn't. That's fixed at the source (the redundant
     inclusion is removed), but this guard stays as a defensive safety
     net: if this file is ever accidentally included twice again by this
     or any other section, the second execution is a safe no-op instead
     of silently double-binding every event listener in here (cart
     drawer open/close, qty +/-, remove, upsell add-to-cart, quick-add).
     Confirmed live during that bug: view_cart fired twice and the
     Remove button behaved inconsistently — exactly what this prevents. */
  if (window.__mcCartInit) return;
  window.__mcCartInit = true;

  /* Free-ship threshold comes from theme setting via data attribute
     (cart drawer or cart page). Falls back to $100 if not present. */
  function getFreeShipCents() {
    var el = document.querySelector('[data-free-ship-cents]');
    var v = el && parseInt(el.getAttribute('data-free-ship-cents'), 10);
    return (v && !isNaN(v)) ? v : 10000;
  }
  var FREE_SHIP_CENTS = getFreeShipCents(); // set from theme setting, in the SHOP currency (USD)
  var STANDARD_SHIP_CENTS = 999;            // standard rate, also USD

  /* Currency: the free-shipping minimum and the $9.99 standard rate are US dollars, but cart.js amounts are in the
     visitor's presentment currency (international market sessions). Convert the USD constants with Shopify's own rate
     before comparing or formatting, and format every amount in the active currency (never a bare "$" on Rs. amounts). */
  var SHOP_CUR = (function () {
    var el = document.querySelector('[data-shop-currency]');
    return (el && el.getAttribute('data-shop-currency')) || 'USD';
  })();
  var ACTIVE_CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || SHOP_CUR;
  var CUR_RATE = (ACTIVE_CUR === SHOP_CUR) ? 1 : (parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
  function toActive(shopCents) { return Math.round(shopCents * CUR_RATE); }
  function freeShipActive() { return toActive(FREE_SHIP_CENTS); }
  function standardShipActive() { return toActive(STANDARD_SHIP_CENTS); }

  /* Club Diamond members ship free at any cart value (flag set server-side). */
  function isDiamond() { return !!document.querySelector('[data-club-diamond="true"]'); }
  /* Same rule as checkout: free at/above the threshold (after discounts) or for Diamond. */
  /* Mitchell & Ness items ship free on their own shipping profile, so only the other items count toward the free-shipping threshold; an all-M&N (or empty) cart ships free. */
  function nonMnCents(cart) { var o = 0, n = 0, items = cart.items || []; items.forEach(function (it) { if ((it.vendor || '') === 'Mitchell & Ness') { n++; } else { o += it.final_line_price || 0; } }); return (items.length && n === items.length) ? -1 : o; }
  function shipBarCents(cart) { var b = nonMnCents(cart); return b < 0 ? freeShipActive() : b; }
  function shipCents(cart) { var b = nonMnCents(cart); return (isDiamond() || !cart.item_count || b < 0 || b >= freeShipActive()) ? 0 : standardShipActive(); }
  function shipHtml(cart) {
    return shipCents(cart) === 0 ? '<span style="color:#1B7A3D;font-weight:700">FREE</span>' : money(standardShipActive());
  }

  /* ── helpers ── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ENG-09: polite screen-reader announcement through the page's shared live region (layout/theme.liquid). */
  function say(msg) {
    try { if (window.mcAnnounce && msg) window.mcAnnounce(msg); } catch (e) { /* no-op */ }
  }
  function itemsWord(n) { return n + (n === 1 ? ' item' : ' items'); }
  /* What a line change really did, judged from the cart Shopify returned (see lineChangeOutcome). */
  function announceLineChange(o, itemEl) {
    var titleEl = itemEl && itemEl.querySelector('.mc-cart-item__title');
    var title = (titleEl && titleEl.textContent.trim()) || (o.line && o.line.product_title) || 'Item';
    if (o.removed) {
      say(title + ' removed. ' + (o.cart.item_count ? itemsWord(o.cart.item_count) + ' in your cart.' : 'Your cart is empty.'));
    } else if (o.notice) {
      say(o.notice);
    } else if (o.line) {
      say(title + ', quantity ' + o.line.quantity + '. Cart total ' + money(o.cart.total_price) + '.');
    }
  }

  /* Real race-condition fix (referral-code-race-condition-add-to-cart-
     prompt.md) — reads the mc_ref_code cookie set by layout/theme.liquid
     and returns it as a cart-attributes fragment to merge into a /cart/
     add.js call, so the code lands in the SAME request that adds the
     item instead of racing a separate background sync call. */
  function mcGetReferralAttribute() {
    var m = document.cookie.match(/(?:^|; )mc_ref_code=([^;]*)/);
    return m ? { mc_ref_code: decodeURIComponent(m[1]) } : {};
  }
  var moneyFmt = null;
  function money(cents) {
    var n = cents / 100;
    if (ACTIVE_CUR === 'USD') return '$' + n.toFixed(2);
    try {
      moneyFmt = moneyFmt || new Intl.NumberFormat('en-US', { style: 'currency', currency: ACTIVE_CUR });
      return moneyFmt.format(n);
    } catch (e) { return ACTIVE_CUR + ' ' + n.toFixed(2); }
  }

  /* Line-level discounts (e.g. the automatic Club grading discount): struck-through
     original price + final price, and one line per discount with the amount saved. */
  function linePriceHtml(item) {
    var was = (item.original_line_price != null && item.original_line_price !== item.final_line_price)
      ? '<s class="mc-cart-item__was">' + money(item.original_line_price) + '</s>' : '';
    return was + '<span>' + money(item.final_line_price != null ? item.final_line_price : item.line_price) + '</span>';
  }
  function lineDiscountsHtml(item) {
    return (item.line_level_discount_allocations || []).map(function (a) {
      var title = (a.discount_application && a.discount_application.title) || 'Discount';
      return '<div class="mc-cart-item__disc">' + escHtml(title) + ' &minus; ' + money(a.amount) + '</div>';
    }).join('');
  }
  function refreshLineDiscounts(itemEl, item) {
    if (!itemEl || !item) return;
    var box = itemEl.querySelector('.mc-cart-item__discs');
    if (box) box.innerHTML = lineDiscountsHtml(item);
  }

  /* ══════════════════════════════════════════════
     CART DRAWER
  ══════════════════════════════════════════════ */
  function initCartDrawer() {
    var drawer  = $('#mc-cart-drawer');
    var overlay = $('#mc-cart-overlay');
    var closeBtn = $('#mc-cart-drawer-close');
    var viewFull = $('#mc-cart-view-full');

    if (!drawer) return;

    var lastFocus = null;
    function isOpen() { return drawer.classList.contains('mc-cart-drawer--active'); }

    /* opts.skeleton = { title, image }: opened by the click on Add to Cart, before the add request has answered. The
       drawer opens at once with a placeholder line; the real line replaces it the moment /cart/add.js answers. */
    function open(opts) {
      opts = opts || {};
      if (!isOpen()) lastFocus = opts.opener || document.activeElement;
      drawer.classList.add('mc-cart-drawer--active');
      overlay.classList.add('mc-cart-overlay--active');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('aria-hidden', 'false');
      /* ENG-08: drawer becomes focusable, the page behind it inert, Tab stays inside, focus goes to Close */
      if (window.mcDialog) window.mcDialog.open(drawer, { opener: lastFocus, keep: [overlay], initialFocus: closeBtn });
      else if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) { /* no-op */ } }

      if (opts.skeleton) {
        renderDrawerSkeleton(opts.skeleton);
      } else {
        /* Show the last known cart immediately, then reconcile with the real one (one shared request). */
        if (lastCart) renderDrawer(lastCart);
        fetchCart(renderDrawer);
      }
      /* Real fix (ga4-analytics-tracking-prompt.md part 3) — view_cart, real fires when the drawer opens.
         Fired after the drawer has rendered; it reuses the shared cart request (window.mcGetCart). */
      if (!opts.skeleton) fireViewCart();
    }

    /* view_cart analytics: after the drawer has rendered, never blocking it; reuses the shared cart request. */
    function fireViewCart() {
      setTimeout(function () {
        if (window.mcTrack && typeof window.mcTrack.viewCart === 'function') window.mcTrack.viewCart();
      }, 0);
    }

    function close() {
      drawer.classList.remove('mc-cart-drawer--active');
      overlay.classList.remove('mc-cart-overlay--active');
      document.body.style.overflow = '';
      drawer.setAttribute('aria-hidden', 'true');
      /* ENG-08: release the page, make the closed drawer unfocusable, return focus to the opener */
      if (window.mcDialog) window.mcDialog.close(drawer);
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* no-op */ } }
      lastFocus = null;
    }

    /* Trigger: cart icon in nav uses data-cart-trigger */
    $$('[data-cart-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open({ opener: btn }); });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);
    if (viewFull) viewFull.addEventListener('click', function () {
      close();
      window.location.href = '/cart';
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('mc-cart-drawer--active')) close();
    });

    /* Re-render drawer when external "add to cart" fires. syncCartCount() and the drawer re-render share ONE
       /cart.js request (getCart), instead of one each. */
    document.addEventListener('mc:cart-updated', function () {
      syncCartCount();
      if (isOpen()) {
        fetchCart(renderDrawer);
      }
    });

    /* Add to Cart was just clicked (request in flight): open the drawer now with a placeholder line. */
    document.addEventListener('mc:cart-adding', function (e) {
      open({ skeleton: (e && e.detail) || {} });
    });

    /* The add request answered: /cart/add.js returns the added line item, so draw it straight away (and update the
       count badge) without waiting for another round trip. The real cart reconciles right after via mc:cart-updated. */
    document.addEventListener('mc:cart-added', function (e) {
      var item = e && e.detail && e.detail.item;
      if (!item || !item.key) return;
      say((item.product_title || item.title || 'Item') + ' added to your cart.');
      cartVersion++;
      var merged = mergeAddedIntoCart(lastCart, item);
      if (merged) {
        lastCart = merged;
        syncCartCount(merged.item_count);
        if (isOpen()) renderDrawer(merged);
      } else if (isOpen()) {
        renderDrawerAddedOnly(item);
      }
      if (isOpen()) fireViewCart();
    });

    /* The add failed (sold out, not enough stock, network): take the placeholder away and close the drawer; the
       button on the page already shows the message. */
    document.addEventListener('mc:cart-add-failed', function () {
      say('We couldn\'t add that item to your cart.');
      if (!isOpen()) return;
      if (lastCart) renderDrawer(lastCart);
      close();
    });

    /* Open drawer from PDP add-to-cart (no-op when the click already opened it) */
    document.addEventListener('mc:open-cart-drawer', function () {
      if (!isOpen()) open();
    });

    /* Line controls: bound ONCE on the (permanent) items container; the lines inside are re-rendered from the server cart. */
    var drawerItemsEl = $('#mc-cart-drawer-items');
    if (drawerItemsEl) bindItemActions(drawerItemsEl, drawerChange);

    /* Discount code in drawer */
    initDiscount(
      '#mc-drawer-discount-input',
      '#mc-drawer-discount-apply',
      '#mc-drawer-discount-msg',
      '#mc-cart-checkout-link'
    );
  }

  /* ── shared cart state ──
     Root cause of the slow drawer: one Add to Cart fired 4-6 separate GET /cart.js (count badge, drawer, view_cart
     analytics, the add handler's own events). Shopify answers cart reads one at a time right after a write, so the one the
     drawer waited for came back last (1.6-2.8 s). Now every caller shares ONE in-flight request per cart version. */
  var cartVersion = 0;      // bumped whenever the cart is known to have changed (add / change)
  var cartReq = null;       // { v, p }: the in-flight request and the version it was started for
  var lastCart = null;      // newest cart we have seen (also drives the optimistic drawer)
  function getCart() {
    if (cartReq && cartReq.v === cartVersion) return cartReq.p;
    var v = cartVersion;
    var p = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (cartReq && cartReq.p === p) cartReq = null;
        if (v === cartVersion || !lastCart) lastCart = c;
        return c;
      }, function (e) {
        if (cartReq && cartReq.p === p) cartReq = null;
        throw e;
      });
    cartReq = { v: v, p: p };
    return p;
  }
  window.mcGetCart = getCart;

  /* ── fetch /cart.js (shared) ── */
  function fetchCart(cb) {
    getCart()
      .then(cb)
      .catch(function (err) { console.warn('MC Cart fetch error', err); });
  }

  /* Merge the line returned by /cart/add.js into the last known cart (same key = quantity update). */
  function mergeAddedIntoCart(base, item) {
    if (!base || !base.items) return null;
    var c = JSON.parse(JSON.stringify(base));
    var idx = -1;
    c.items.forEach(function (it, i) { if (it.key === item.key) idx = i; });
    var added = item.quantity;
    if (idx >= 0) {
      added = item.quantity - c.items[idx].quantity;
      c.total_price -= c.items[idx].final_line_price;
      c.original_total_price -= c.items[idx].original_line_price;
      c.items[idx] = item;
    } else {
      c.items.unshift(item);
    }
    c.total_price += item.final_line_price;
    c.original_total_price += item.original_line_price;
    c.item_count += added;
    c.total_discount = Math.max(0, c.original_total_price - c.total_price);
    return c;
  }

  function skeletonLineHtml(info) {
    info = info || {};
    var img = info.image ? '<img src="' + escHtml(info.image) + '" alt="" loading="eager">' : '';
    return '<div class="mc-cart-item mc-cart-item--compact mc-cart-item--skeleton" aria-busy="true">' +
      '<div class="mc-cart-item__img">' + img + '</div>' +
      '<div class="mc-cart-item__info">' +
        '<div class="mc-cart-item__title">' + (info.title ? escHtml(info.title) : '<span class="mc-cart-skel__bar"></span>') + '</div>' +
        '<div class="mc-cart-skel__bar mc-cart-skel__bar--short"></div>' +
      '</div>' +
      '<div class="mc-cart-item__price"><span class="mc-cart-skel__bar mc-cart-skel__bar--price"></span></div>' +
    '</div>';
  }

  /* Placeholder while /cart/add.js is in flight: the last known cart underneath (if any) with a placeholder line on top. */
  function renderDrawerSkeleton(info) {
    var itemsEl = $('#mc-cart-drawer-items');
    var footEl  = $('#mc-cart-drawer-foot');
    if (!itemsEl) return;
    if (lastCart && lastCart.items && lastCart.items.length) {
      renderDrawer(lastCart, true);
      itemsEl.insertAdjacentHTML('afterbegin', skeletonLineHtml(info));
    } else {
      itemsEl.innerHTML = skeletonLineHtml(info);
      if (footEl) footEl.style.display = 'none';
    }
    itemsEl.scrollTop = 0;
  }

  /* No known cart to merge into: draw just the added line until the real cart arrives. */
  function renderDrawerAddedOnly(item) {
    renderDrawer({
      items: [item], item_count: item.quantity, total_price: item.final_line_price,
      original_total_price: item.original_line_price, total_discount: Math.max(0, item.original_line_price - item.final_line_price)
    }, true);
  }

  /* ── render drawer with cart data ── */
  function renderDrawer(cart, noRecs) {
    var countEl  = $('#mc-cart-drawer-count');
    var itemsEl  = $('#mc-cart-drawer-items');
    var footEl   = $('#mc-cart-drawer-foot');

    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
    syncCartCount(cart.item_count);
    updateFreeShipBar(shipBarCents(cart), '#mc-drawer-freeship-text', '#mc-drawer-freeship-fill');

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="mc-cart-empty">' +
          '<div class="mc-cart-empty__icon">🛒</div>' +
          '<div class="mc-cart-empty__text">Your cart is empty</div>' +
          '<a href="/collections/all" class="mc-cart-empty__btn">Start Shopping</a>' +
        '</div>';
      if (footEl) footEl.style.display = 'none';
      clearRecommendations('mc-cart-drawer-upsells');
      return;
    }

    if (footEl) footEl.style.display = '';

    /* Items */
    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="" loading="lazy">'
        : '<span class="mc-cart-item__img-placeholder">📦</span>';

      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="mc-cart-item__variant">' + item.variant_title + '</div>'
        : '';

      return (
        '<div class="mc-cart-item mc-cart-item--compact" data-key="' + item.key + '" data-track-product-id="' + item.product_id + '" data-track-title="' + escHtml(item.product_title) + '" data-track-price="' + (item.price / 100) + '" data-track-qty="' + item.quantity + '">' +
          '<div class="mc-cart-item__img">' + img + '</div>' +
          '<div class="mc-cart-item__info">' +
            '<a href="' + item.url + '" class="mc-cart-item__title">' + escHtml(item.product_title) + '</a>' +
            variant +
            '<div class="mc-cart-item__discs">' + lineDiscountsHtml(item) + '</div>' +
            '<div class="mc-cart-item__actions">' +
              '<div class="mc-cart-item__qty">' +
                '<button class="mc-cart-item__qty-btn" data-key="' + item.key + '" data-action="decrease" aria-label="Decrease quantity">−</button>' +
                '<span class="mc-cart-item__qty-num">' + item.quantity + '</span>' +
                '<button class="mc-cart-item__qty-btn" data-key="' + item.key + '" data-action="increase" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="mc-cart-item__remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="mc-cart-item__price">' + linePriceHtml(item) + '</div>' +
        '</div>'
      );
    }).join('');

    /* A message waiting for one of these lines (rejected quantity, failed request) */
    applyPendingNotice(itemsEl);

    /* Totals */
    updateDrawerTotals(cart);

    /* "You Might Also Like" — anchored on the most-recently-added item. Loaded after the lines and totals are on screen,
       never blocking them (and skipped when this was only an optimistic/placeholder render). */
    if (!noRecs) fetchAndRenderRecommendations(cart, 'mc-cart-drawer-upsells', 'drawer');
  }

  function updateDrawerTotals(cart) {
    var totalsEl    = $('#mc-cart-drawer-totals');
    var checkoutBtn = $('#mc-cart-checkout-link');

    /* An empty cart has nothing to pay: no shipping estimate, no total, no checkout button. */
    if (!cart || !cart.item_count) {
      var emptyFoot = $('#mc-cart-drawer-foot');
      if (emptyFoot) emptyFoot.style.display = 'none';
      return;
    }

    if (totalsEl) {
      var freeShip = shipCents(cart) === 0;
      totalsEl.innerHTML =
        '<div class="mc-cart-drawer__total-row">' +
          '<span>Subtotal</span><span>' + money(cart.original_total_price != null ? cart.original_total_price : cart.total_price) + '</span>' +
        '</div>' +
        (cart.total_discount > 0
          ? '<div class="mc-cart-drawer__total-row mc-cart-drawer__total-row--disc"><span>Discounts</span><span>&minus;' + money(cart.total_discount) + '</span></div>'
          : '') +
        '<div class="mc-cart-drawer__total-row' + (freeShip ? ' mc-cart-drawer__total-row--free' : '') + '">' +
          '<span>Shipping</span>' +
          '<span>' + shipHtml(cart) + '</span>' +
        '</div>' +
        '<div class="mc-cart-drawer__note">' + (isDiamond() ? 'Diamond member &middot; ' : '') + 'Express shipping available at checkout.</div>' +
        '<div class="mc-cart-drawer__total-row mc-cart-drawer__total-row--est">' +
          '<span>Estimated total</span><span>' + money(cart.total_price + shipCents(cart)) + '</span>' +
        '</div>';
    }

    if (checkoutBtn) {
      checkoutBtn.textContent = 'Checkout — ' + money(cart.total_price);
    }
  }

  /* ══════════════════════════════════════════════
     FREE SHIPPING BAR
  ══════════════════════════════════════════════ */
  function updateFreeShipBar(totalCents, textSel, fillSel) {
    var textEl = $(textSel);
    var fillEl = $(fillSel);
    if (!textEl && !fillEl) return;
    if (isDiamond()) {
      var wrap = (textEl || fillEl).closest('.mc-free-ship');
      if (wrap) wrap.style.display = 'none';
      return;
    }

    var thr = freeShipActive();
    var pct = Math.min((totalCents / thr) * 100, 100);
    if (fillEl) fillEl.style.width = pct + '%';

    if (textEl) {
      if (totalCents >= thr) {
        textEl.className = 'mc-free-ship__text mc-free-ship__text--unlocked';
        textEl.innerHTML = '✅ You\'ve unlocked <strong>FREE shipping!</strong>';
      } else {
        var remaining = money(thr - totalCents);
        textEl.className = 'mc-free-ship__text';
        textEl.innerHTML =
          '🚚 Add <strong class="mc-free-ship__amount">' + remaining + '</strong> more for ' +
          '<strong class="mc-free-ship__label">FREE shipping</strong>';
      }
    }
  }

  /* ══════════════════════════════════════════════
     FULL CART PAGE
  ══════════════════════════════════════════════ */
  function initCartPage() {
    var page = $('.mc-cart-page');
    if (!page) return;

    /* Real fix (ga4-analytics-tracking-prompt.md part 3) — view_cart, real fires when the real cart page loads (the drawer's own open() covers the drawer surface separately). */
    if (window.mcTrack && typeof window.mcTrack.viewCart === 'function') window.mcTrack.viewCart();

    /* Read server-rendered cart total for free-ship bar */
    var totalCents = parseInt(page.dataset.cartTotal || '0', 10);
    updateFreeShipBar(totalCents, '#mc-page-freeship-text', '#mc-page-freeship-fill');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateFreeShipBar(shipBarCents(c), '#mc-page-freeship-text', '#mc-page-freeship-fill'); }).catch(function () {});

    /* Bind qty/remove on all page items (once; the lines are re-rendered from the server cart after every change) */
    bindItemActions(page, pageChange);

    /* Discount code on cart page */
    initDiscount(
      '#mc-page-discount-input',
      '#mc-page-discount-apply',
      '#mc-page-discount-msg',
      '#mc-page-checkout-btn'
    );

    /* "You Might Also Like" — initial render on load, refreshed on every
       mc:cart-updated (including the dispatch just added above, and the
       existing dispatch already fired by initUpsells()'s add-to-cart). */
    fetchCart(function (cart) { fetchAndRenderRecommendations(cart, 'mc-cart-page-upsells', 'page'); });
    document.addEventListener('mc:cart-updated', function () {
      fetchCart(function (cart) {
        /* Empty page, but something was added elsewhere (another tab / the drawer): show the real cart. */
        if (page.classList.contains('mc-cart-page--empty') && cart.item_count > 0) { window.location.reload(); return; }
        fetchAndRenderRecommendations(cart, 'mc-cart-page-upsells', 'page');
      });
    });
  }

  /* ── Full cart: one change = one request; the page is then redrawn from the cart Shopify returns ── */
  var pageChangeSeq = 0;
  function pageChange(key, qty, itemEl, track) {
    var mine = ++pageChangeSeq;
    setItemLoading(itemEl, true);
    return changeLineItem(key, qty).then(function (res) {
      var o = lineChangeOutcome(res, key, qty);
      if (mine !== pageChangeSeq) return;          /* a newer change has started: its answer will draw the page */
      announceLineChange(o, itemEl);
      var draw = function () {
        if (o.removed) fireRemoveTrack(track);
        pendingNotice = o.notice ? { key: key, text: o.notice } : null;
        renderPage(o.cart);
      };
      if (o.removed && itemEl && itemEl.parentNode) slideOut(itemEl, draw); else draw();
    }).then(function () { setItemLoading(itemEl, false); },
            function (err) {
              console.warn('MC cart change error', err);
              setItemLoading(itemEl, false);
              showLineNotice(itemEl, MSG_NETWORK);
              say(MSG_NETWORK);
            });
  }

  function pageItemHtml(item) {
    var imgUrl = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    var img = imgUrl
      ? '<img src="' + escHtml(imgUrl) + '" alt="' + escHtml(item.product_title) + '" width="64" height="64" loading="lazy">'
      : '<span class="mc-cart-item__img-placeholder">📦</span>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="mc-cart-item__variant">' + escHtml(item.variant_title) + '</div>' : '';
    var props = '';
    var pr = item.properties;
    var ripLine = !!(pr && typeof pr === 'object' && pr._rip_stream_id != null && String(pr._rip_stream_id) !== '');
    if (ripLine) {
      /* Rip & Ship line: same block the Liquid cart prints; the Stream text is the label the product-page picker wrote */
      var ripStream = String(pr['Stream'] == null ? '' : pr['Stream']).trim().replace(' \u2014 ', ', ');
      props += '<div class="mc-rs-cart"><div class="mc-rs-cart__row"><span class="mc-rs-cart__icon" aria-hidden="true">\uD83C\uDFA5</span><span class="mc-rs-cart__text">' +
        (ripStream ? '<strong>Opens live:</strong> ' + escHtml(ripStream) : '<strong>Opens live on stream</strong>') +
        '</span></div><div class="mc-rs-cart__sub">Your cards ship after the opening.</div></div>';
    }
    if (pr && typeof pr === 'object') {
      Object.keys(pr).forEach(function (k) {
        var v = pr[k];
        if (k.charAt(0) === '_' || k === 'Service Level' || v == null || String(v) === '') return;
        if (ripLine && (k === 'Fulfilment' || k === 'Stream')) return;
        props += '<div class="mc-cart-item__prop">' + escHtml(v) + '</div>';
      });
    }
    return (
      '<div class="mc-cart-item" data-key="' + escHtml(item.key) + '" data-track-product-id="' + item.product_id + '" data-track-title="' + escHtml(item.product_title) + '" data-track-price="' + (item.price / 100) + '" data-track-qty="' + item.quantity + '">' +
        '<div class="mc-cart-item__img">' + img + '</div>' +
        '<div class="mc-cart-item__info">' +
          '<a href="' + escHtml(item.url) + '" class="mc-cart-item__title">' + escHtml(item.product_title) + '</a>' +
          variant +
          '<div class="mc-cart-item__discs">' + lineDiscountsHtml(item) + '</div>' +
          (props ? '<div class="mc-cart-item__props">' + props + '</div>' : '') +
          '<div class="mc-cart-item__actions">' +
            '<div class="mc-cart-item__qty">' +
              '<button class="mc-cart-item__qty-btn" data-key="' + escHtml(item.key) + '" data-action="decrease" aria-label="Decrease quantity">−</button>' +
              '<span class="mc-cart-item__qty-num">' + item.quantity + '</span>' +
              '<button class="mc-cart-item__qty-btn" data-key="' + escHtml(item.key) + '" data-action="increase" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="mc-cart-item__remove" data-key="' + escHtml(item.key) + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="mc-cart-item__price">' + linePriceHtml(item) + '</div>' +
      '</div>'
    );
  }

  /* Redraw the whole full-cart page body from a cart object (always the one Shopify just returned). */
  function renderPage(cart, quiet) {
    var page = $('.mc-cart-page');
    syncCartCount(cart.item_count);
    var countEl = $('#mc-page-item-count');
    if (countEl) countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ' in your cart';

    if (page && cart.item_count === 0) {
      renderPageEmpty(page);
    } else if (page) {
      var card = $('.mc-cart-page__items-card', page);
      if (card) {
        $$('.mc-cart-item', card).forEach(function (el) { el.remove(); });
        card.insertAdjacentHTML('beforeend', cart.items.map(pageItemHtml).join(''));
        applyPendingNotice(card);
      }
      updatePageTotals(cart);
      updateFreeShipBar(shipBarCents(cart), '#mc-page-freeship-text', '#mc-page-freeship-fill');
    }
    /* Nothing on this page knew the cart had changed (recommendations row etc.). `quiet`: the change came from the drawer,
       which has already drawn itself (and may be showing a message), so don't make it re-fetch and redraw. */
    if (!quiet) document.dispatchEvent(new CustomEvent('mc:cart-updated'));
  }

  /* DATA-13: an empty cart is only the empty message + a way back to the shop: no summary, no total, no checkout button. */
  function renderPageEmpty(page) {
    var left = $('.mc-cart-page__left', page);
    var card = $('.mc-cart-page__items-card', page);
    var faq  = $('.mc-cart-faq', page);
    if (card) card.remove();
    if (faq) faq.remove();
    if (left && !$('.mc-cart-page__empty', left)) {
      var sub = $('#mc-page-item-count', left);
      var emptyHtml =
        '<div class="mc-cart-page__empty">' +
          '<div class="mc-cart-page__empty-icon">🛒</div>' +
          '<div class="mc-cart-page__empty-text">Your cart is empty</div>' +
          '<a href="/collections/all" class="mc-cart-page__empty-btn">Start Shopping</a>' +
        '</div>';
      if (sub) sub.insertAdjacentHTML('afterend', emptyHtml); else left.insertAdjacentHTML('beforeend', emptyHtml);
    }
    var summary = $('.mc-cart-summary', page);
    if (summary) summary.style.display = 'none';
    page.classList.add('mc-cart-page--empty');
    clearRecommendations('mc-cart-page-upsells');
  }

  function updatePageTotals(cart) {
    var subtotalEl  = $('#mc-page-subtotal');
    var shippingEl  = $('#mc-page-shipping');
    var totalEl     = $('#mc-page-total');

    if (subtotalEl) subtotalEl.textContent = money(cart.original_total_price != null ? cart.original_total_price : cart.total_price);
    var discRow = $('#mc-page-discounts-row'), discEl = $('#mc-page-discounts');
    if (discRow && discEl) {
      discRow.style.display = cart.total_discount > 0 ? '' : 'none';
      discEl.innerHTML = '&minus;' + money(cart.total_discount || 0);
    }
    if (totalEl)    totalEl.textContent    = money(cart.total_price + shipCents(cart));
    if (shippingEl) shippingEl.innerHTML = shipHtml(cart);
  }

  /* ══════════════════════════════════════════════
     LOADING STATE HELPERS
  ══════════════════════════════════════════════ */
  function setItemLoading(itemEl, loading) {
    if (!itemEl) return;
    if (loading) {
      itemEl.classList.add('mc-cart-item--loading');
      itemEl.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    } else {
      itemEl.classList.remove('mc-cart-item--loading');
      itemEl.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
    }
  }

  /* ══════════════════════════════════════════════
     SHARED: BIND ITEM ACTIONS (qty +/- and remove)
  ══════════════════════════════════════════════ */
  function trackInfoFor(itemEl) {
    if (!itemEl) return null;
    return {
      id: itemEl.dataset.trackProductId,
      title: itemEl.dataset.trackTitle,
      price: parseFloat(itemEl.dataset.trackPrice) || 0,
      quantity: parseInt(itemEl.dataset.trackQty, 10) || 1
    };
  }
  /* remove_from_cart is only reported once the cart really lost the line (a rejected request is not a removal). */
  function fireRemoveTrack(info) {
    try { if (info && window.mcTrack && typeof window.mcTrack.removeFromCart === 'function') window.mcTrack.removeFromCart(info); } catch (e) { /* no-op */ }
  }

  function bindItemActions(ctx, onChange) {
    if (ctx.__mcItemsBound) return;      /* one listener per container, however many times the lines are redrawn */
    ctx.__mcItemsBound = true;
    /* Use event delegation so it works after AJAX re-renders */
    ctx.addEventListener('click', function (e) {
      /* Qty buttons */
      var qtyBtn = e.target.closest('.mc-cart-item__qty-btn');
      if (qtyBtn && ctx.contains(qtyBtn) && !qtyBtn.disabled) {
        var key     = qtyBtn.dataset.key;
        var action  = qtyBtn.dataset.action;
        var itemEl  = qtyBtn.closest('.mc-cart-item');
        var qtyEl   = itemEl && itemEl.querySelector('.mc-cart-item__qty-num');
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);
        /* The "-" button dropping quantity to 0 is a real removal too, same as the explicit Remove button below
           (its analytics event now fires only after the cart confirms the line is gone). */
        clearLineNotice(itemEl);
        onChange(key, newQty, itemEl, newQty === 0 ? trackInfoFor(itemEl) : null);
        return;
      }

      /* Remove buttons */
      var removeBtn = e.target.closest('.mc-cart-item__remove');
      if (removeBtn && ctx.contains(removeBtn) && !removeBtn.disabled) {
        var itemEl2 = removeBtn.closest('.mc-cart-item');
        /* The real item's data is read from its own element BEFORE it can be removed (shared between the drawer's
           JS-rendered items and the cart page's lines: both carry the same data-track-* attributes). */
        clearLineNotice(itemEl2);
        onChange(removeBtn.dataset.key, 0, itemEl2, trackInfoFor(itemEl2));
      }
    });
  }

  /* ══════════════════════════════════════════════
     AJAX: CHANGE LINE ITEM
     Returns a Promise: { ok, cart, description }.
       ok:false  = Shopify rejected the change (stock limit, stale line key ...); `cart` is then the REAL cart from /cart.js.
       A network failure rejects the Promise (callers show a message and clear their loading state).
     Callers never write the requested quantity on screen: they redraw from `cart`.
  ══════════════════════════════════════════════ */
  var MSG_NETWORK = 'We couldn\'t update your cart. Check your connection and try again.';
  var pendingNotice = null;   /* { key, text }: shown on that line by the next redraw */

  function readJson(r) {
    return r.text().then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } });
  }
  function cssAttr(v) { return String(v).replace(/\\/g, '\\\\').replace(/"/g, '\\"'); }

  function changeLineItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        return readJson(r).then(function (body) {
          if (r.ok && body && body.items) return { ok: true, cart: body };
          var desc = body && typeof body.description === 'string' ? body.description : (body && typeof body.message === 'string' ? body.message : '');
          /* Rejected: ask for the real cart instead of guessing */
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
            .then(function (r2) { if (!r2.ok) throw new Error('cart.js ' + r2.status); return r2.json(); })
            .then(function (cart) { return { ok: false, cart: cart, description: desc }; });
        });
      })
      .then(function (res) {
        if (res && res.cart && res.cart.items) { cartVersion++; lastCart = res.cart; }
        return res;
      });
  }

  /* What really happened to this line, judged from the cart Shopify returned (never from the requested quantity). */
  function lineChangeOutcome(res, key, qty) {
    var cart = res.cart, line = null;
    cart.items.forEach(function (i) { if (i.key === key) line = i; });
    var out = { cart: cart, line: line, removed: false, notice: '' };
    if (qty === 0) {
      if (!line) out.removed = true;
      else out.notice = 'We couldn\'t remove this item. Please try again.';
    } else if (!line) {
      out.notice = 'Your cart had changed, so we refreshed it. Please check your items.';
    } else if (line.quantity !== qty) {
      var base = res.description || 'That quantity isn\'t available.';
      out.notice = base + ' Your cart still has ' + line.quantity + '.';
    }
    return out;
  }

  /* Drawer: same flow; the lines are redrawn from the returned cart. */
  function drawerChange(key, qty, itemEl, track) {
    setItemLoading(itemEl, true);
    return changeLineItem(key, qty).then(function (res) {
      var o = lineChangeOutcome(res, key, qty);
      announceLineChange(o, itemEl);
      if (o.removed) fireRemoveTrack(track);
      pendingNotice = o.notice ? { key: key, text: o.notice } : null;
      renderDrawer(o.cart);
      /* The full cart page behind the drawer (when this is /cart) shows the same cart. */
      if ($('.mc-cart-page')) renderPage(o.cart, true);
    }).then(function () { setItemLoading(itemEl, false); },
            function (err) {
              console.warn('MC cart change error', err);
              setItemLoading(itemEl, false);
              showLineNotice(itemEl, MSG_NETWORK);
              say(MSG_NETWORK);
            });
  }

  /* Show the waiting message on its line; if that line is no longer in the cart (stale key), show it above the lines. */
  function applyPendingNotice(container) {
    if (!pendingNotice || !container) return;
    var line = container.querySelector('.mc-cart-item[data-key="' + cssAttr(pendingNotice.key) + '"]');
    if (line) showLineNotice(line, pendingNotice.text);
    else container.insertAdjacentHTML('afterbegin', '<div class="mc-cart-item__msg mc-cart-item__msg--general" role="alert">' + escHtml(pendingNotice.text) + '</div>');
    pendingNotice = null;
  }

  function showLineNotice(itemEl, text) {
    if (!itemEl) return;
    clearLineNotice(itemEl);
    var info = itemEl.querySelector('.mc-cart-item__info') || itemEl;
    var d = document.createElement('div');
    d.className = 'mc-cart-item__msg';
    d.setAttribute('role', 'alert');
    d.textContent = text;
    info.appendChild(d);
  }
  function clearLineNotice(itemEl) {
    if (!itemEl) return;
    var m = itemEl.querySelector('.mc-cart-item__msg');
    if (m) m.remove();
  }

  /* ══════════════════════════════════════════════
     "YOU MIGHT ALSO LIKE" — automatic recommendations
     Real fix (2026-08-13) — Shopify's native, zero-setup /recommendations/
     products.json endpoint (`related` intent, algorithmic, no manual
     curation). Anchored on whichever cart item was most recently added
     (the last entry in cart.items — matches add order for genuinely new
     lines; an existing line whose quantity was just bumped stays in place,
     but that item is excluded from its own recommendations anyway by the
     already-in-cart filter below, so the fallback is still a valid
     "recommendations minus what's already in the cart" result either way).
     Deliberately separate from initUpsells() below, which is the CURATED
     "Frequently Added Together" mechanism (a fixed collection) — this one
     is fully automatic and has no admin-configurable collection at all.
     Both reuse the same [data-upsell-variant] add-to-cart click pattern
     (bound once, globally, in initUpsells()) so recommendation cards work
     without any extra event binding here.
  ══════════════════════════════════════════════ */
  function clearRecommendations(containerId) {
    var el = document.getElementById(containerId);
    if (el) el.innerHTML = '';
  }

  /* Drawer: small horizontal-scroll cards (image + name side by side).
     Page: wide grid cards (image on top, full width). Deliberately
     different DOM shapes, not just a class swap — see
     cart-page-recommendations-layout-fix-prompt.md. */
  /* Cart DRAWER "You Might Also Like" -> "View All" destination. One place to change it. */
  var UPSELL_VIEW_ALL_URL = '/collections/all?sort_by=best-selling';

  function renderUpsellCardHtml(p, context) {
    var variants = p.variants || [];
    var variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (!variant) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';

    if (context === 'page') {
      /* Reuse the site's standard product card (snippets/monmouth-product-card.liquid)
         instead of a bespoke design — same classes, styled by
         monmouth-product-card.css (already loaded sitewide). Field names below
         are verified against a live /recommendations/products.json response,
         not guessed: prices are raw cents on both product.price and
         variant.price/variant.compare_at_price; featured_image is a plain CDN
         URL string (or null); url is already a full relative path with the
         recommendation-tracking query string built in. See
         cart-recommendations-card-format-prompt.md. */
      var titleEsc = escHtml(p.title);
      var isSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      return (
        '<div class="mc-product-card">' +
          '<a href="' + p.url + '" class="mc-product-card__img-link">' +
            '<div class="mc-product-card__img">' +
              (img
                ? '<img src="' + img + '" alt="' + titleEsc + '" width="200" height="280" loading="lazy" class="mc-product-card__image">'
                : '') +
            '</div>' +
          '</a>' +
          '<div class="mc-product-card__body">' +
            '<a href="' + p.url + '" class="mc-product-card__title" title="' + titleEsc + '">' + titleEsc + '</a>' +
            '<div class="mc-product-card__price' + (isSale ? ' mc-product-card__price--sale' : '') + '">' +
              '<span class="mc-product-card__price-current">' + money(variant.price) + '</span>' +
              (isSale ? '<span class="mc-product-card__price-compare">' + money(variant.compare_at_price) + '</span>' : '') +
            '</div>' +
            '<button class="mc-product-card__btn' + (variant.available ? '' : ' mc-product-card__btn--soldout') + '" data-upsell-variant="' + variant.id + '"' +
              (variant.available ? '' : ' disabled') + '>' +
              (variant.available ? 'Add to Cart' : 'Sold Out') +
            '</button>' +
          '</div>' +
        '</div>'
      );
    }

    return (
      '<div class="mc-cart-upsell-row">' +
        '<div class="mc-cart-upsell-row__img">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="mc-cart-upsell-row__info">' +
          '<div class="mc-cart-upsell-row__name">' + escHtml(p.title) + '</div>' +
          '<div class="mc-cart-upsell-row__price">' + money(variant.price) + '</div>' +
        '</div>' +
        '<button class="mc-cart-upsell-row__btn" data-upsell-variant="' + variant.id + '"' +
          (variant.available ? '' : ' disabled') + '>' +
          (variant.available ? 'Add to Cart' : 'Sold Out') +
        '</button>' +
      '</div>'
    );
  }

  function renderRecommendationsHtml(products, context) {
    var cards = products.map(function (p) { return renderUpsellCardHtml(p, context); }).filter(Boolean);

    if (!cards.length) return '';

    if (context === 'page') {
      return (
        '<div class="mc-cart-page-upsells__title">You Might Also Like</div>' +
        '<div class="mc-cart-page-upsells__row">' + cards.join('') + '</div>'
      );
    }

    return (
      '<div class="mc-cart-upsells">' +
        '<div class="mc-cart-upsells__head">' +
          '<div class="mc-cart-upsells__title">You Might Also Like</div>' +
          '<a class="mc-cart-upsells__viewall" href="' + UPSELL_VIEW_ALL_URL + '">View All ' +
            '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>' +
          '</a>' +
        '</div>' +
        '<div class="mc-cart-upsells__list">' + cards.join('') + '</div>' +
      '</div>'
    );
  }

  function fetchAndRenderRecommendations(cart, containerId, context) {
    if (!document.getElementById(containerId)) return;

    if (!cart.items.length) {
      clearRecommendations(containerId);
      return;
    }

    /* Anchor on whichever product was most recently added. cart.items
       order is not reliably append-order on this store (confirmed live —
       a fresh add can land at index 0), so we track the last-added
       variant id explicitly (set by every /cart/add.js call site) and
       fall back to the last array item only if that lookup fails. */
    var anchor = null;
    try {
      var lastVariantId = sessionStorage.getItem('mc_last_added_variant_id');
      if (lastVariantId) {
        anchor = cart.items.filter(function (i) {
          return String(i.variant_id) === String(lastVariantId);
        })[0] || null;
      }
    } catch (e) { /* sessionStorage unavailable */ }
    if (!anchor) anchor = cart.items[cart.items.length - 1];
    var cartProductIds = cart.items.map(function (i) { return i.product_id; });

    var displayLimit = (context === 'page') ? 5 : 4;
    var recsEl = document.getElementById(containerId);
    var recsKey = anchor.product_id + ':' + cartProductIds.join(',');
    if (recsEl && recsEl.dataset.recsFor === recsKey && recsEl.children.length) return;
    if (recsEl) recsEl.dataset.recsFor = recsKey;
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(anchor.product_id) + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var products = (data && data.products) || [];
        var filtered = products
          .filter(function (p) { return cartProductIds.indexOf(p.id) === -1; })
          .slice(0, displayLimit);

        var el = document.getElementById(containerId);
        if (!el) return; /* container may have been removed by a later re-render */

        if (!filtered.length) {
          el.innerHTML = '';
          return;
        }
        el.innerHTML = renderRecommendationsHtml(filtered, context);
      })
      .catch(function () {
        /* Fail quietly — no empty state, no error message (per spec) */
        clearRecommendations(containerId);
      });
  }

  /* ══════════════════════════════════════════════
     UPSELL: ADD TO CART
  ══════════════════════════════════════════════ */
  /* ══════════════════════════════════════════════
     PRODUCT-CARD QUICK ADD (collection/related grids)
     Real fix (ga4-analytics-tracking-prompt.md part 4) — this used to be
     a plain, non-JS form POST to /cart/add with no AJAX response to hook
     tracking into at all (a full-page redirect to the cart). Delegated
     so it works for every real monmouth-product-card.liquid instance
     sitewide, including ones rendered after this script runs (related
     products, infinite-scroll collection grids).
  ══════════════════════════════════════════════ */
  function initProductCardQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.mc-product-card__quick-add-form');
      if (!form) return;
      e.preventDefault();

      var idInput = form.querySelector('[name="id"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!idInput || !btn) return;

      var original = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      /* Open the drawer right away with a placeholder line (replaced by the real line when the add answers). */
      var card = form.closest('.mc-product-card');
      var cardTitleEl = card && card.querySelector('.mc-product-card__title, h3, h2');
      var cardImgEl = card && card.querySelector('img');
      document.dispatchEvent(new CustomEvent('mc:cart-adding', { detail: {
        title: cardTitleEl ? cardTitleEl.textContent.trim() : '',
        image: cardImgEl ? (cardImgEl.currentSrc || cardImgEl.src) : ''
      } }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            document.dispatchEvent(new CustomEvent('mc:cart-add-failed'));
            btn.textContent = data.description || 'Error';
            btn.disabled = false;
            setTimeout(function () { btn.textContent = original; }, 2000);
            return;
          }
          btn.textContent = '✓ Added!';
          try { sessionStorage.setItem('mc_last_added_variant_id', String(data.variant_id || idInput.value)); } catch (e2) { /* no-op */ }

          /* Line + badge from the add response now; real cart reconciles via mc:cart-updated (one shared request). */
          document.dispatchEvent(new CustomEvent('mc:cart-added', { detail: { item: data } }));
          document.dispatchEvent(new CustomEvent('mc:cart-updated'));
          document.dispatchEvent(new CustomEvent('mc:open-cart-drawer'));

          /* Analytics never blocks the drawer: fire-and-forget after it has rendered. */
          setTimeout(function () {
            try {
              if (window.mcTrack && typeof window.mcTrack.addToCart === 'function') {
                window.mcTrack.addToCart({
                  id: data.product_id || idInput.value,
                  title: data.product_title || data.title,
                  price: (typeof data.price === 'number' ? data.price / 100 : undefined)
                }, 1);
              }
            } catch (e2) { /* no-op */ }
          }, 0);
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          document.dispatchEvent(new CustomEvent('mc:cart-add-failed'));
          btn.textContent = 'Error';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = original; }, 2000);
        });
    });
  }

  function initUpsells() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-variant]');
      if (!btn) return;

      var variantId = btn.dataset.upsellVariant;
      var original  = btn.textContent;
      btn.textContent = '…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, attributes: mcGetReferralAttribute() })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.textContent = '✓ Added';
          if (data && !data.status) say((data.product_title || data.title || 'Item') + ' added to your cart.');
          try { sessionStorage.setItem('mc_last_added_variant_id', String((data && data.variant_id) || variantId)); } catch (e) { /* no-op */ }

          /* Real fix (ga4-analytics-tracking-prompt.md part 4) — this real, working AJAX add-to-cart path (cart-drawer upsells) never called mcTrack.addToCart at all. */
          try {
            if (window.mcTrack && typeof window.mcTrack.addToCart === 'function' && data) {
              window.mcTrack.addToCart({
                id: data.product_id || variantId,
                title: data.product_title || data.title,
                price: (typeof data.price === 'number' ? data.price / 100 : undefined)
              }, 1);
            }
          } catch (e) { /* no-op */ }

          syncCartCount();
          document.dispatchEvent(new CustomEvent('mc:cart-updated'));
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  }

  /* ══════════════════════════════════════════════
     DISCOUNT CODE
     Discount codes can't be applied via AJAX in Shopify, and this theme cannot check one. So the box is honest:
     it SAVES the code and hands it to checkout (/discount/{CODE}?redirect=/checkout), where Shopify decides if it
     is eligible. The saved code is shown with Change / Remove, an empty Apply clears it, and the drawer and the
     full cart always show the same state. Storage is wrapped so a blocked sessionStorage never breaks the cart.
  ══════════════════════════════════════════════ */
  var DC_KEY = 'mc_discount_code';
  /* The saved code lives in this variable for the page's lifetime (so a blocked sessionStorage cannot break anything) and
     is mirrored to sessionStorage so it survives page loads. */
  var dcMem = (function () { try { return sessionStorage.getItem(DC_KEY) || ''; } catch (e) { return ''; } })();
  var dcSurfaces = [];            /* every discount box on this page: { inputEl, msgEl, checkoutEl } */
  function dcGet() { return dcMem || ''; }
  function dcSet(code) { dcMem = code; try { sessionStorage.setItem(DC_KEY, code); } catch (e) { /* no-op */ } }
  function dcClear() { dcMem = ''; try { sessionStorage.removeItem(DC_KEY); } catch (e) { /* no-op */ } }
  function dcLooksValid(code) { return code.length <= 60 && !/[\s\/\\?#%]/.test(code); }

  function dcMsgBase(msgEl) { return (msgEl.id && msgEl.id.indexOf('drawer') > -1) ? 'mc-cart-discount__msg' : 'mc-cart-summary__discount-msg'; }
  function dcSetMsg(msgEl, kind, html) {
    if (!msgEl) return;
    var base = dcMsgBase(msgEl);
    ['success', 'note', 'error'].forEach(function (k) { msgEl.classList.remove(base + '--' + k); });
    if (!html) { msgEl.style.display = 'none'; msgEl.innerHTML = ''; return; }
    msgEl.classList.add(base + '--' + kind);
    msgEl.style.display = 'block';
    msgEl.innerHTML = html;
  }

  /* Draw the saved state (or none) on every discount box, and keep the checkout links in step. */
  function dcRenderAll() {
    var code = dcGet();
    dcSurfaces.forEach(function (s) {
      if (code) {
        if (s.inputEl) s.inputEl.value = code;
        dcSetMsg(s.msgEl, 'success',
          '✅ Code saved: <strong>' + escHtml(code) + '</strong>. Eligibility is checked at checkout. ' +
          '<button type="button" class="mc-dc-link" data-dc="change">Change</button> · ' +
          '<button type="button" class="mc-dc-link" data-dc="remove">Remove</button>');
        if (s.checkoutEl) s.checkoutEl.setAttribute('href', '/discount/' + encodeURIComponent(code) + '?redirect=/checkout');
      } else {
        if (s.msgEl && s.msgEl.dataset.dcKind !== 'error') dcSetMsg(s.msgEl, 'note', '');
        if (s.checkoutEl) s.checkoutEl.setAttribute('href', '/checkout');
      }
      if (s.msgEl) s.msgEl.dataset.dcKind = code ? 'saved' : '';
    });
  }

  function initDiscount(inputSel, applySel, msgSel, checkoutSel) {
    var inputEl    = $(inputSel);
    var applyBtn   = $(applySel);
    var msgEl      = $(msgSel);
    var checkoutEl = $(checkoutSel);

    if (!inputEl || !applyBtn) return;
    dcSurfaces.push({ inputEl: inputEl, msgEl: msgEl, checkoutEl: checkoutEl });
    dcRenderAll();

    applyBtn.addEventListener('click', function () {
      var code = inputEl.value.trim().toUpperCase();
      if (!code) {                       /* empty Apply = clear any saved code */
        dcClear();
        dcSurfaces.forEach(function (s) { if (s.msgEl) s.msgEl.dataset.dcKind = ''; if (s.inputEl) s.inputEl.value = ''; });
        dcRenderAll();
        say('Discount code removed.');
        return;
      }
      if (!dcLooksValid(code)) {
        if (msgEl) { msgEl.dataset.dcKind = 'error'; dcSetMsg(msgEl, 'error', 'That doesn\'t look like a discount code. Please remove spaces and symbols.'); }
        say('That doesn\'t look like a discount code. Please remove spaces and symbols.');
        return;
      }
      dcSet(code);
      dcRenderAll();
      say('Discount code ' + code + ' saved. Eligibility is checked at checkout.');
    });

    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyBtn.click();
    });

    if (msgEl) msgEl.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-dc]');
      if (!b) return;
      if (b.getAttribute('data-dc') === 'remove') {
        dcClear();
        dcSurfaces.forEach(function (s) { if (s.inputEl) s.inputEl.value = ''; });
        dcRenderAll();
        say('Discount code removed.');
      } else {                           /* Change: edit the saved code in the box */
        inputEl.focus();
        try { inputEl.select(); } catch (e2) { /* no-op */ }
      }
    });
  }

  /* ══════════════════════════════════════════════
     CART COUNT BADGE
  ══════════════════════════════════════════════ */
  function syncCartCount(count) {
    if (count !== undefined) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      return;
    }
    fetchCart(function (cart) { syncCartCount(cart.item_count); });
  }

  /* ══════════════════════════════════════════════
     UTILS
  ══════════════════════════════════════════════ */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function slideOut(el, cb) {
    el.style.overflow = 'hidden';
    el.style.transition = 'opacity 0.18s, height 0.28s ease, padding 0.28s ease, margin 0.28s ease';
    el.style.height = el.offsetHeight + 'px';
    el.style.opacity = '1';
    requestAnimationFrame(function () {
      el.style.height = '0';
      el.style.paddingTop = '0';
      el.style.paddingBottom = '0';
      el.style.marginTop = '0';
      el.style.marginBottom = '0';
      el.style.opacity = '0';
    });
    setTimeout(cb, 300);
  }

  /* ══════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════ */
  function init() {
    initCartDrawer();
    initCartPage();
    initUpsells();
    initProductCardQuickAdd();

    /* Prime the shared cart once the page has settled (so the first add can render instantly), and finish the
       server-rendered free-shipping bar/totals for visitors whose currency is not the shop currency (the server cannot
       convert, so it prints a neutral line for them). */
    setTimeout(function () {
      getCart().then(function (cart) {
        syncCartCount(cart.item_count);
        if (ACTIVE_CUR !== SHOP_CUR) {
          updateFreeShipBar(shipBarCents(cart), '#mc-drawer-freeship-text', '#mc-drawer-freeship-fill');
          updateFreeShipBar(shipBarCents(cart), '#mc-page-freeship-text', '#mc-page-freeship-fill');
          if ($('#mc-cart-drawer-totals') && cart.item_count > 0) updateDrawerTotals(cart);
          if ($('#mc-page-shipping')) updatePageTotals(cart);
        }
      }).catch(function () { /* no-op */ });
    }, 600);
  }

  /* Global helpers for Liquid-rendered cart items that use inline onclick: same flow as the buttons on the full cart. */
  window.mcCartQty = function (key, qty) {
    var itemEl = document.querySelector('.mc-cart-item[data-key="' + cssAttr(key) + '"]');
    return pageChange(key, qty, itemEl, qty === 0 ? trackInfoFor(itemEl) : null);
  };

  window.mcCartRemove = function (key) {
    return window.mcCartQty(key, 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
